/* eslint-disable */
// Promise.allSettled Polyfill
export const allSettledPolyfill = (): void => {
  if (!Promise.allSettled) {
    const rejectHandler = (reason: unknown) => ({ status: 'rejected', reason });
    const resolveHandler = (value: unknown) => ({ status: 'fulfilled', value });

    Promise.allSettled = (promises: any) => Promise.all(
      promises.map(
        (p: PromiseLike<unknown>) => Promise.resolve(p).then(resolveHandler, rejectHandler),
      ),
    );
  }
};
